import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    title: "Дерево категорий",
    "is-content-loading": _ctx.isCategoryListLoading
  }, {
    content: _withCtx(() => [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
          return (_openBlock(), _createElementBlock("li", {
            key: category.name
          }, [
            _createElementVNode("ul", null, _toDisplayString(_ctx.getNameWithDepth(category.name, category.depth)), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-content-loading"]))
}